import { Table } from '@aws-amplify/ui-react'
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Button, EditContainer, Flex, MainHeadline, PageFooter, PageWrapper, Th, Tr } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { InventoryIssueModal } from './InventoryIssueModal'
import { clearInventoryIssues, getInventoryIssues } from 'features/inventory/inventoryIssuesSlice'
import { IGetAllInventoryIssuesSingleResponse } from 'types/api/inventoryReceiptsApi.interface'
import { Options } from 'components/Options/Options'
import { ViewInventoryIssueModal } from './ViewInventoryIssueModal'
import { ArrowLeft } from 'assets/icons/ArrowLeft'

export const InventoryIssues = () => {
    const { issues, totalPages } = useSelector((store: RootState) => store.inventoryIssues)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState(false)
    const [viewModal, setViewModal] = useState<{ open: boolean, value: IGetAllInventoryIssuesSingleResponse }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getInventoryIssues], cleanUpFunctions: [clearInventoryIssues], params })

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Inventory Issues</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => setModal(true)} >
                        Add Issue
                    </Button>
                </Flex>

            </Flex>
            {!issues.length ? (
                <NoItems title='Issues' />
            ) : (
                <Table width='100%' >
                    <Th >
                        <Td w='15%' noTooltip text='DATE' />
                        <Td w='15%' noTooltip text='PERFORMED BY' />
                        <Td w='15%' noTooltip text='ASSIGNED EMPLOYEE' />
                        <Td w='15%' noTooltip text='FROM LOCATION' />
                        <Td w='30%' noTooltip text='ITEMS' />
                        <Td w='5%' noTooltip text='' />
                    </Th>
                    {issues.map((item) => {
                        return (
                            <Tr onClick={() => setViewModal({ open: true, value: item })} view key={item.id}>
                                <Td w='15%' text={formatDateForDisplay(item.date, true)} />
                                <Td w='15%' text={item.performedByUser ? (item.performedByUser.firstName + ' ' + item.performedByUser.lastName) : '/'} />
                                <Td w='15%' text={item.assignedForUser ? (item.assignedForUser.firstName + ' ' + item.assignedForUser.lastName) : '/'} />
                                <Td w='15%' text={item.fromLocation ? item.fromLocation.name : '/'} />
                                <Td w='30%' text={item.lines.length || '/'} />
                                <Td options w='5%'>
                                    <EditContainer onClick={() => setViewModal({ open: true, value: item })} >
                                        <Flex style={{ transform: 'rotate(180deg)' }} className='arrow-table' >
                                            <ArrowLeft />
                                        </Flex>
                                    </EditContainer>
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
            {modal && <InventoryIssueModal closeModal={() => setModal(false)} />}
            {viewModal.open && <ViewInventoryIssueModal value={viewModal.value} closeModal={() => setViewModal({ value: null, open: false })} />}

        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}